const ellipsis = {
    maxWidth: '280px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

/** Colunas da lista de solicitantes (FindEmployeeData: id, name, email). */
export const DELIVERY_REQUESTER_LIST_COLUMNS = [
    {
        header: 'ID',
        accessor: 'id',
        sortable: false,
        render: (item) => (item?.id != null ? String(item.id) : '—'),
    },
    {
        header: 'Nome',
        accessor: 'name',
        sortable: false,
        render: (item) => (
            <div style={ellipsis} title={item?.name || undefined}>
                {item?.name || '—'}
            </div>
        ),
    },
    {
        header: 'Email',
        accessor: 'email',
        sortable: false,
        render: (item) => (
            <div style={ellipsis} title={item?.email || undefined}>
                {item?.email || '—'}
            </div>
        ),
    },
];
